import { connect } from "react-redux"
import ImageVideoCarouselWidget from "QuorumGrassroots/widgets/ImageVideoCarousel/components/index"
import { fullWidthWidgetConnection } from "QuorumGrassroots/widgets/selectors"

export default connect(fullWidthWidgetConnection, null)(ImageVideoCarouselWidget)
